<template>
    <List
        :form="form"
    />
</template>

<script>
// Components
import List from '../components/historico-medicamento/List'

export default {
    components: { List },
    props: {
        form: { type: Object, default: null }
    },
}
</script>